export const OLD_SELLER_URL = 'https://admin.ze.delivery/'
export const keysOrderHistorySearch = {
  CUSTOMER_NAME: 'CUSTOMER_NAME',
  ORDER_NUMBER: 'ORDER_NUMBER',
}
